import { render, staticRenderFns } from "./InsuranceProtectionDateNotice.vue?vue&type=template&id=23bd4f12&scoped=true&"
import script from "./InsuranceProtectionDateNotice.vue?vue&type=script&lang=js&"
export * from "./InsuranceProtectionDateNotice.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceProtectionDateNotice.vue?vue&type=style&index=0&id=23bd4f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd4f12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
